import { BaseControl } from "./BaseControl";
import { Controller } from "./Controller";

export class MultilineControl extends BaseControl {

    constructor(protected textarea: HTMLTextAreaElement, controller: Controller, field: string) {
        super(controller, field);

        if (controller.automaticUpdateModel) {
            // save new value on lost focus
            textarea.addEventListener("blur", this.onBlur);
        }
    }

    onBlur = (ev: Event) => {
        this.saveValue(this.textarea.value);
    }

    dispose() {
        this.textarea.removeEventListener("blur", this.onBlur);
    }

    updateControlFromModel() {
        let value = this.getModelValue();
        this.textarea.value = value ? value : "";
    }

    updateModelFromControl() {
        this.setModelValue(this.textarea.value);
    }

    validate() {
    }

    focus() {
        this.textarea.focus();
    }
}
